import type { ChordVariant, QualityQuestion } from '@tunasong/music-lib'
import { chordToEvents } from '../player/chord-to-events.js'
import { type Stab, useStabScheduler } from '../player/stab-scheduler.js'

/**
 * Ear Training Chord-quality ID audition: one block-chord stab at delay 0,
 * sustained ~1.2 s (half-note at 100 BPM). Strict block — all notes start
 * simultaneously; no strum stagger (Bowie §8.3).
 *
 * Spec: docs/superpowers/specs/2026-05-20-ear-training-suite-design.md §4.5
 */
export const buildQualityStabs = (chord: ChordVariant, octave: number): Stab[] => [
  { events: chordToEvents(chord, '2n', octave), delayMs: 0 },
]

export interface UseQualityPlaybackProps {
  question: QualityQuestion | null
}

/**
 * Hook returning `{ play, stop }`. Thin wrapper over `useStabScheduler`.
 * A null question → empty stab list → no-op play, so the caller can mount
 * the hook unconditionally regardless of the active sub-mode.
 */
export const useQualityPlayback = (props: UseQualityPlaybackProps): { play: () => void; stop: () => void } => {
  const { play, stop } = useStabScheduler({
    buildStabs: () =>
      props.question ? buildQualityStabs(props.question.chord, props.question.rootOctave) : [],
  })
  return { play, stop }
}
